export default {
  // Delivery information labels
  recipientName: "Recipient Name",
  contactPhone: "Contact Phone",
  deliveryAddress: "Delivery Address",
  quantity: "Quantity",
  time: "Time",
};
